<template>
  <div class="rightCon">
    <commonHeader title="手动记录列表"></commonHeader>
    <header class="list_header">
      <ul>
        <li :class="{ active: currentTab === 0 }" @click="changeTab(0)">全部({{ all }})</li>
        <li :class="{ active: currentTab === 1 }" @click="changeTab(1)">未报备({{ noReport }})</li>
        <li :class="{ active: currentTab === 2 }" @click="changeTab(2)">已报备({{ report }})</li>
      </ul>
    </header>
    <section class="list_con">
      <section v-if="list.length > 0">
        <ul class="list">
          <li class="list_item" v-for="(item, index) in list" :key="index">
            <div class="item_header">
              <div class="header_left">
                <img src="./location.png" />
                <span>{{ item.districtName }}-{{ item.unitName }}</span>
              </div>
              <span class="btn" :class="{ active: item.status == 1 }">{{
                item.status == 1 ? '已报备' : '未报备'
              }}</span>
            </div>
            <p class="item_desc">设备名称：{{ item.deviceName }}</p>
            <p class="item_desc">切换时间：{{ item.alarmTime }}</p>
            <p class="item_desc" v-if="item.status == 1">报备原因：{{ item.reasonTypeName }}</p>
          </li>
        </ul>
        <div class="footer">
          <el-pagination
            :total="total"
            :current-page="pageIndex"
            :page-size="pageSize"
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
          ></el-pagination>
        </div>
      </section>
      <div class="no_data" v-else>暂无数据</div>
    </section>
  </div>
</template>

<script>
  import commonHeader from '../commonHeader.vue'
  export default {
    name: 'rightCon',
    components: {
      commonHeader
    },
    data() {
      return {
        list: [],
        all: 0,
        noReport: 0,
        report: 0,
        timer: null,
        pageIndex: 1,
        pageSize: 5,
        total: 0,
        currentTab: 0
      }
    },
    props: {
      areaId: {
        type: String | Number
      }
    },
    watch: {
      areaId: {
        handler(val) {
          this.pageIndex = 1
          this.currentTab = 0
          this.getData()
          this.startTimer()
        },
        immediate: true
      }
    },
    methods: {
      changeTab(index) {
        this.currentTab = index
        this.pageIndex = 1
        this.getData()
        this.startTimer()
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.getData()
        this.startTimer()
      },
      getData() {
        this.$axiospost('operation/automatic/hand/detection/queryRightStatics', {
          parentAreaId: this.areaId,
          recordType: this.currentTab,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }).then(res => {
          if (res.data.status == 10000) {
            const { list, all, report, noReport } = res.data.data
            if (list != null && Object.keys(list).length > 0) {
              this.list = list.list
              this.total = list.total
            } else {
              this.list = []
              this.total = 0
            }
            this.all = all
            this.report = report
            this.noReport = noReport
          }
        })
      },
      // 新增：启动定时器
      startTimer() {
        this.stopTimer() // 先清除可能存在的定时器
        this.timer = setInterval(() => {
          this.getData()
        }, 5 * 60 * 1000) // 5分钟 = 300000毫秒
      },
      // 新增：停止定时器
      stopTimer() {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      }
    },
    beforeDestroy() {
      clearInterval(this.stopTimer)
    }
  }
</script>

<style lang="less" scoped>
  .rightCon {
    width: 4.69rem;
    position: absolute;
    right: 0.31rem;
    top: 9.46vh;
    bottom: 4.67vh;
    z-index: 1;
    .list_header {
      margin-top: 0.93vh;
      height: 4.92vh;
      background: url('./tab_bg.png') no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;

      ul {
        height: 100%;
        display: flex;
        align-items: center;
        font-family: SourceHanSansCN-Light;
        font-size: 1.67vh;
        color: #fff;

        li {
          height: 100%;
          padding: 0 0.15rem;
          cursor: pointer;
          line-height: 3.92vh;

          &.active {
            background: url('./tab_active.png') no-repeat;
            background-size: 100% 100%;
            color: #4fbdff;
          }
        }
      }
    }

    .list_con {
      height: calc(100% - 4.92vh - 0.93vh - 5vh);
      background-image: linear-gradient(0deg, rgba(0, 14, 46, 0.3) 0%, rgba(54, 81, 147, 0.6) 100%);
      background-blend-mode: normal, normal;

      section {
        height: 100%;
      }

      .list {
        height: calc(100% - 8.81vh);
        padding: 0 0.21rem;
        // height: 100%;
        overflow-y: auto;

        li {
          padding: 1.48vh 0;
          border-bottom: 1px dashed #29b0ff;

          .item_header {
            margin-bottom: 0.73vh;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .header_left {
              display: flex;
              align-items: center;

              img {
                width: 0.16rem;
                height: auto;
              }

              span {
                margin-left: 0.05rem;
                font-family: 'SourceHanSansCN-Light';
                font-size: 1.48vh;
                // line-height: 1;
                color: #31b4ff;
              }
            }

            .btn {
              width: 0.7rem;
              height: 2.32vh;
              display: inline-block;
              text-align: center;
              line-height: 2.32vh;
              font-family: SourceHanSansCN-Light;
              font-size: 1.3vh;
              color: #fff;
              background: url('./un_report.png') no-repeat;
              background-size: 100% 100%;
            }

            .btn.active {
              background-image: url('./reported.png');
            }
          }

          p {
            font-family: SourceHanSansCN-Light;
            font-size: 1.3vh;
            color: #fff;
            // line-height: 1.1;

            &:not(:last-child) {
              margin-bottom: 0.73vh;
            }
          }
        }
      }

      .no_data {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.3vh;
        color: rgba(255, 255, 255, 0.6);
      }
    }

    .footer {
      margin-top: 1vh;
      width: 100%;
      display: flex;
      justify-content: center;

      /deep/ .el-pagination {
        margin-top: 0;

        .el-pager {
          li {
            border: 1px solid #306ac9;
            background: transparent;
            color: #c3c3c3;
            margin-left: 10px;
            padding: 0;
          }

          li.active {
            background: #306ac9;
            color: #c3c3c3;
          }
        }

        .btn-prev,
        .btn-next,
        button:disabled {
          border: 1px solid #306ac9;
          background: transparent;
          color: #c3c3c3;
          margin-left: 10px;
          padding: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pumpMonitor/rightCon/index.vue